import VideoPlayer from './VideoPlayer.vue'
export default VideoPlayer
